/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.35.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CAFMember } from './cafmember';
import { Citizen } from './citizen';

/**
 * 
 * @export
 * @interface ServiceRequestStatus
 */
export interface ServiceRequestStatus {
    /**
     * 
     * @type {string}
     * @memberof ServiceRequestStatus
     */
    documentId?: string;
    /**
     * 
     * @type {number}
     * @memberof ServiceRequestStatus
     */
    citizenId?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceRequestStatus
     */
    cafMemberId?: number;
    /**
     * 
     * @type {Citizen}
     * @memberof ServiceRequestStatus
     */
    citizen?: Citizen;
    /**
     * 
     * @type {CAFMember}
     * @memberof ServiceRequestStatus
     */
    cafMember?: CAFMember;
    /**
     * 
     * @type {string}
     * @memberof ServiceRequestStatus
     */
    turn?: ServiceRequestStatusTurnEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceRequestStatus
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRequestStatus
     */
    updated_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ServiceRequestStatusTurnEnum {
    Citizen = 'citizen',
    CafMember = 'cafMember',
    Admin = 'admin',
    Finalized = 'finalized',
    Expired = 'expired',
    Refund = 'refund'
}



